/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DefaultSettingsViewDefaultSetting { 
    /**
     * The unique identifier of this record.
     */
    defaultSettingId?: number;
    name?: string;
    description?: string;
    defaultValue?: string;
    groupName?: string;
    type?: DefaultSettingsViewDefaultSetting.TypeEnum;
    granularity?: DefaultSettingsViewDefaultSetting.GranularityEnum;
}
export namespace DefaultSettingsViewDefaultSetting {
    export type TypeEnum = 'string' | 'integer' | 'boolean' | 'number' | 'timestamp';
    export const TypeEnum = {
        String: 'string' as TypeEnum,
        Integer: 'integer' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Number: 'number' as TypeEnum,
        Timestamp: 'timestamp' as TypeEnum
    };
    export type GranularityEnum = 'organisation' | 'venue';
    export const GranularityEnum = {
        Organisation: 'organisation' as GranularityEnum,
        Venue: 'venue' as GranularityEnum
    };
}